module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('a', {
    attrs: {
      "href": "#/06_Acknowledgement#acknowledgement",
      "id": "toc-acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Foreword#foreword",
      "id": "toc-foreword"
    }
  }, [_vm._v("Foreword by Brigadier Christopher Thursby-Pelham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Prologue#prologue",
      "id": "toc-prologue"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Chapter1#ch1",
      "id": "toc-ch1"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter I")]), _vm._v(" Joining Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter2#ch2",
      "id": "toc-ch2"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter II")]), _vm._v(" Training")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter3#ch3",
      "id": "toc-ch3"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter III")]), _vm._v(" Advance to Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter4#ch4",
      "id": "toc-ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter IV")]), _vm._v(" Cassino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter5#ch5",
      "id": "toc-ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter V")]), _vm._v(" Cassino II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter6#ch6",
      "id": "toc-ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter VI")]), _vm._v(" The Battle Before Arce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter7#ch7",
      "id": "toc-ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter VII")]), _vm._v(" Perugia to Florence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter8#ch8",
      "id": "toc-ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter VIII")]), _vm._v(" The Gothic Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter9#ch9",
      "id": "toc-ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter IX")]), _vm._v(" The Apennines to the Adriatic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter10#ch10",
      "id": "toc-ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Chapter X")]), _vm._v(" The Po, the Alps and Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Epilogue#epilogue",
      "id": "toc-epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Appendix1#app1",
      "id": "toc-app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Appendix I:")]), _vm._v(" The Four Battles of Cassino")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Appendix2#app2",
      "id": "toc-app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Appendix II:")]), _vm._v(" The Assault on the Gothic Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Appendix3#app3",
      "id": "toc-app3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Appendix III:")]), _vm._v(" Repatriation Agreements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list2"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Appendix4#app4",
      "id": "toc-app4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Appendix IV:")]), _vm._v(" War Diary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-list1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Index#index",
      "id": "toc-index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2169bf9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_Contents.vue
// module id = 69
// module chunks = 0